import { ActionType } from 'src/types/common/common';
import { ResponsiveTabAdaptor } from 'src/constrains/DraggableModules/Components';
import { dispatch } from '@/src/store';
import { onLoadData } from 'src/constrains/ResponsiveLayerEditor/slice';
import { generateTabProduct } from 'src/constrains/DraggableModules/tools';

const ResponsiveProductTabFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  onCollapseOpen,
}) => {
  const handleOnProductItemChange = (id, index, modifiedData) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.modify,
        id,
        data: {
          index,
          modifiedData,
        },
      });
    }
  };
  const handleOnProductItemReselect = (id, images) => {
    // const _n = optionsToNum[ProductType] || 1;
    // const _o = data || [generateResponsiveImage()];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.reselect, id, data: images });
    }
  };

  const handleOnProductItemSort = (id, from, to) => {
    if (onDynamicChange) {
      onDynamicChange({
        type: ActionType.reorder,
        id,
        data: {
          from,
          to,
        },
      });
    }
  };

  const handleOnProductStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };

  const handleOnProductItemDelete = (id, index) => {
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.delete, id, data: { index } });
    }
  };

  const handleOnCloseAllCollapses = () => {
    if (onCollapseOpen) onCollapseOpen([]);
  };

  const handleOnProductModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(data);
    }
  };

  const handleOnProductItemAdd = (id, data) => {
    // const _n = optionsToNum[ProductType] || 1;
    //
    const _o = data || [generateTabProduct()];
    if (onDynamicChange) {
      onDynamicChange({ type: ActionType.add, id, data: _o });
    }
  };

  const handleOnOpenImageTab = (data) => {
    handleOnCloseAllCollapses();
    setTimeout(() => {
      dispatch(onLoadData(data));
    });
  };

  return {
    handleOnProductItemChange,
    handleOnProductItemSort,
    handleOnProductStaticChange,
    handleOnProductModuleTypeChange,
    handleOnOpenImageTab,
    handleOnProductItemReselect,
    handleOnProductItemAdd,
    handleOnProductItemDelete,
  };
};
const generateResponsiveProductTab = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
  onCollapseOpen,
}) => {
  const {
    handleOnProductItemChange,
    handleOnProductItemSort,
    handleOnProductStaticChange,
    handleOnProductModuleTypeChange,
    handleOnOpenImageTab,
    handleOnProductItemReselect,
    handleOnProductItemAdd,
    handleOnProductItemDelete,
  } = ResponsiveProductTabFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
    onCollapseOpen,
  });
  return {
    component: ResponsiveTabAdaptor,
    props: {
      onItemDelete: handleOnProductItemDelete,
      onItemChange: handleOnProductItemChange,
      onItemSort: handleOnProductItemSort,
      onStaticChange: handleOnProductStaticChange,
      onModuleTypeChange: handleOnProductModuleTypeChange,
      onOpenNewTab: handleOnOpenImageTab,
      onItemReselect: handleOnProductItemReselect,
      onItemAdd: handleOnProductItemAdd,
    },
  };
};
export { generateResponsiveProductTab };
